const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
/** `MM-DD`, used for season windows that repeat every year. */
const MONTH_DAY_RE = /^\d{2}-\d{2}$/;
export function isPlainDate(value) {
    if (typeof value !== 'string' || !DATE_RE.test(value))
        return false;
    const d = new Date(`${value}T00:00:00.000Z`);
    return !Number.isNaN(d.getTime()) && toPlainDate(d) === value;
}
export function isMonthDay(value) {
    if (typeof value !== 'string' || !MONTH_DAY_RE.test(value))
        return false;
    const month = Number(value.slice(0, 2));
    const day = Number(value.slice(3, 5));
    if (month < 1 || month > 12 || day < 1 || day > 31)
        return false;
    // Use a leap year so 02-29 stays valid.
    return new Date(Date.UTC(2024, month - 1, day)).getUTCDate() === day;
}
export function toPlainDate(d) {
    return d.toISOString().slice(0, 10);
}
export function parsePlainDate(value) {
    return new Date(`${value}T00:00:00.000Z`);
}
export function addDays(value, days) {
    const d = parsePlainDate(value);
    d.setUTCDate(d.getUTCDate() + days);
    return toPlainDate(d);
}
export function addMonths(value, months) {
    const d = parsePlainDate(value);
    const targetDay = d.getUTCDate();
    d.setUTCDate(1);
    d.setUTCMonth(d.getUTCMonth() + months);
    // Clamp to the end of the target month (31 Jan + 1 month -> 28/29 Feb).
    const lastDay = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 0)).getUTCDate();
    d.setUTCDate(Math.min(targetDay, lastDay));
    return toPlainDate(d);
}
/** 0 = Sunday … 6 = Saturday, matching `Date.prototype.getUTCDay`. */
export function weekdayOf(value) {
    return parsePlainDate(value).getUTCDay();
}
export function daysBetween(from, to) {
    const ms = parsePlainDate(to).getTime() - parsePlainDate(from).getTime();
    return Math.round(ms / 86_400_000);
}
export function compareDates(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
export function clampDate(value, min, max) {
    return value < min ? min : value > max ? max : value;
}
/** Monday of the ISO week containing `value`. */
export function startOfIsoWeek(value) {
    const weekday = weekdayOf(value);
    const offset = weekday === 0 ? -6 : 1 - weekday;
    return addDays(value, offset);
}
export function monthDayOf(value) {
    return value.slice(5);
}
/**
 * Whether a date falls inside a recurring yearly window.
 * Windows may wrap across new year (Winterdienst: `11-01` .. `03-31`).
 */
export function isWithinSeason(value, seasonStart, seasonEnd) {
    if (!seasonStart || !seasonEnd)
        return true;
    const md = monthDayOf(value);
    if (seasonStart <= seasonEnd)
        return md >= seasonStart && md <= seasonEnd;
    return md >= seasonStart || md <= seasonEnd;
}
/** Today in the given IANA zone, as a plain calendar date. */
export function todayIn(timeZone, now = new Date()) {
    const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(now);
    return parts;
}
export function eachDate(from, to) {
    const out = [];
    for (let d = from; d <= to; d = addDays(d, 1))
        out.push(d);
    return out;
}
//# sourceMappingURL=dates.js.map